export const colors = new Map([
    ["yellow", "#ffdf0066"],
    ["red", "#ff4646"],
    ["blue", "#0064ff"],
    ["green", "#00c564"],
]);
